import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const userConfigsSlice = createSlice({
  name: 'userConfigs',
  initialState,
  reducers: {
    userConfigsRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    userConfigsSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    userConfigsFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    userConfigsReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const userConfigsAction = userConfigsSlice.actions;
export default userConfigsSlice;